<!-- 活动参与者列表项组件 -->
<template>
  <div class="player-item-wrapper">
    <!-- 头像和基本信息 -->
    <div class="titleT">
      <div class="titleCon">
        <div class="titleTop">
          <div class="tx">
            <!-- 头像 -->
            <div class="header">
              <img
                v-if="showAvatar"
                :src="item.profile_photo || anonymousHeadUrl"
                @error="
                  $event.target.src = anonymousHeadUrl
                "
              />
              <img
                v-else
                :src="anonymousHeadUrl"
              />
            </div>
            <!-- 微信昵称 -->
            <div class="content_con">
              <!-- 判断是否显示真实姓名：根据 encryption 和 isOpen -->
              <template v-if="displayName">
                <div class="Biao">
                  {{ displayName }}
                  <img
                    class="no-see"
                    v-if="item.allow_diving == 2"
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/bd-nosee.svg"
                  />
                </div>
              </template>
              <template v-else>
                <div class="Biao">
                  {{ item.name ? item.name : item.nickname }}
                  <img
                    class="no-see"
                    v-if="item.allow_diving == 2"
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/bd-nosee.svg"
                  />
                </div>
              </template>
              <div class="time">
                <span v-if="item.registration_id">
                  ID: {{ item.registration_id }}
                </span>
                接龙时间 {{ item.add_time }}
              </div>
            </div>
          </div>

          <!-- 分数 -->
          <div
            class=""
            style="display: flex; flex-direction: column; align-items: center"
            v-if="item.score"
          >
            <div
              style="
                font-style: italic;
                font-weight: bold;
                color: #f73b42;
                font-size: 19px;
                padding-right: 28px;
              "
            >
              {{ item.score }}
            </div>
          </div>

          <!-- 序号 -->
          <div
            class=""
            style="display: flex; flex-direction: column; align-items: center"
          >
            <div class="xuhao">#{{ item.sign_index }}</div>
          </div>
        </div>

        <!-- 点评内容 -->
        <div
          class="comment_cont"
          v-if="item.addcomment != undefined && item.addcomment"
        >
          {{ item.comment_name }}点评：{{ item.addcomment }}
        </div>
      </div>
    </div>

    <!-- 列表模式下的表单字段内容和操作按钮 -->
    <div
      class="content"
      style="margin-top: 10px !important; padding: 0px !important"
      v-if="
        showContent &&
        (anonymousParticipation == 0 || memberId == item.create_user_id)
      "
    >
      <div class="bmfooter">
        <!-- 付费信息 -->
        <div
          class="footer_text"
          v-if="
            (item.charge_name || item.charge_item_name) &&
            item.unit_price !== undefined &&
            item.unit_price !== null &&
            item.unit_price !== ''
          "
        >
          <div class="mar15-0">
            <span class="playerContentTitle" style="font-weight: 600"
              >付费项:</span
            >
            <span style="color: #323b5f; font-size: 14px; font-weight: 600">{{
              item.charge_name || item.charge_item_name
            }}</span>
          </div>
          <div
            class="mar15-0"
            v-if="
              isOtherPeople == 1 ||
              isOtherPeople == 2 ||
              memberId == item.create_user_id
            "
          >
            <span class="playerContentTitle" style="font-weight: 600"
              >金额:</span
            >
            <span style="color: #323b5f; font-size: 14px; font-weight: 600"
              >¥{{ item.unit_price }}</span
            >
          </div>
        </div>
        <!-- 表单字段内容 -->
        <div
          class="footer_text"
          v-for="(fieldItem, fieldIndex) in item.sign_info"
          :key="fieldIndex"
        >
          <!-- 姓名/性别/手机号/数量/身份证/省市区/时间 -->
          <div
            class="mar15-0"
            v-if="
              (fieldItem.type == 1 ||
                fieldItem.type == 2 ||
                fieldItem.type == 11 ||
                fieldItem.type == 13 ||
                fieldItem.type == 3 ||
                fieldItem.type == 10 ||
                fieldItem.type == 8 ||
                fieldItem.type == 4 ||
                fieldItem.type == 15 ||
                fieldItem.type == 19 ||
                fieldItem.type == 21 ||
                fieldItem.type == 22 ||
                fieldItem.type == 23 ||
                fieldItem.type == 24 ||
                fieldItem.type == 25 ||
                fieldItem.type == 26 ||
                fieldItem.type == 27 ||
                fieldItem.type == 28 ||
                fieldItem.type == 31) &&
              (fieldItem.isOpen == 1 || isOtherPeople != 3)
            "
          >
            <div>
              <span
                style="color: #666666; margin-right: 20px"
                class="playerContentTitle"
                >{{ fieldItem.fieldName }}:</span
              >
              <span style="color: #323b5f; font-size: 14px">{{
                fieldItem.type == 1 && fieldIndex == 0 && item.list_group_name
                  ? item.list_group_name + "-" + (fieldItem.value || "无")
                  : fieldItem.value
                  ? fieldItem.value
                  : "无"
              }}</span>
            </div>
            <div
              v-if="
                fieldItem.areaSelectType == 3 &&
                fieldItem.provinceCityDistrictAddress != null
              "
            >
              <span style="color: #666666"></span
              >{{ fieldItem.provinceCityDistrictAddress }}
            </div>
          </div>

          <!-- 文件 -->
          <div
            v-if="
              fieldItem.type == 32 &&
              (fieldItem.isOpen == 1 || isOtherPeople != 3)
            "
            class="mar15-0"
          >
            <div>
              <span
                style="color: #666666; margin-right: 20px"
                class="playerContentTitle"
                >{{ fieldItem.fieldName }}:</span
              >
              <span
                v-if="fieldItem.value.length == 0"
                style="color: #323b5f; font-size: 14px"
                >无</span
              >
            </div>
            <div
              v-if="fieldItem.value != null"
              class="file-sign-box"
              style="margin-top: 7px"
            >
              <div
                class="file-sign-item"
                style="box-sizing: border-box"
                v-for="(fileItem, fileIndex) in fieldItem.value"
                :key="fileIndex"
              >
                <div
                  class="con4 con4_flex"
                  @click="
                    openWen(
                      imageUrl2 + fileItem.fileUrl,
                      fileItem.lastName,
                      fileItem.name,
                    )
                  "
                >
                  <div class="" style="align-items: center !important">
                    <div style="display: flex">
                      <div class="con4Img">
                        <img
                          v-if="fileItem.lastName == 'doc'"
                          :src="imageUrl2 + '/static/announcement/word.png'"
                          class="Img3"
                        />
                        <img
                          v-else-if="fileItem.lastName == 'docx'"
                          :src="imageUrl2 + '/static/announcement/word.png'"
                          class="Img3"
                        />
                        <img
                          v-else-if="fileItem.lastName == 'pdf'"
                          :src="imageUrl2 + '/static/announcement/PDF.png'"
                          class="Img3"
                        />
                        <img
                          v-else-if="fileItem.lastName == 'ppt'"
                          :src="imageUrl2 + '/static/announcement/PPT.png'"
                          class="Img3"
                        />
                        <img
                          v-else-if="fileItem.lastName == 'xls'"
                          :src="imageUrl2 + '/static/index/excel.png'"
                          class="Img3"
                        />
                        <img
                          v-else-if="fileItem.lastName == 'xlsx'"
                          :src="imageUrl2 + '/static/index/excel.png'"
                          class="Img3"
                        />
                        <img
                          v-else-if="fileItem.lastName == 'zip'"
                          src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/zip.svg"
                          class="Img3"
                        />
                      </div>
                      <div>{{ fileItem.name }}</div>
                    </div>

                    <div class="con4_1">
                      <span v-if="fileItem.size / 1024 <= 1">{{
                        setB(fileItem.size, fileItem.lastName)
                      }}</span>
                      <span
                        v-else-if="
                          fileItem.size / 1024 >= 1 &&
                          fileItem.size / 1048576 <= 1
                        "
                        >{{ setKb(fileItem.size, fileItem.lastName) }}</span
                      >
                      <span v-else-if="fileItem.size / 1048576 >= 1">{{
                        setMb(fileItem.size, fileItem.lastName)
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 多行文本 -->
          <div
            class="newContent mar15-0"
            v-else-if="
              fieldItem.type == 9 &&
              (fieldItem.isOpen == 1 || isOtherPeople != 3)
            "
          >
            <div class="nameMa">
              <span style="color: #666666" class="playerContentTitle"
                >{{ fieldItem.fieldName }}:</span
              >
              <span> {{ fieldItem.value ? "" : "无" }}</span>
              <div
                v-if="fieldItem.value"
                style="
                  color: #323b5f;
                  white-space: pre-wrap;
                  word-break: break-all;
                  word-wrap: break-word;
                  font-size: 14px;
                "
              >
                {{ fieldItem.value }}
              </div>
            </div>
          </div>

          <!-- 图片/视频/录音空值显示 -->
          <div
            class="newContent mar15-0"
            v-else-if="
              (fieldItem.type == 5 ||
                fieldItem.type == 35 ||
                fieldItem.type == 6 ||
                fieldItem.type == 7) &&
              (fieldItem.isOpen == 1 || isOtherPeople != 3) &&
              (!fieldItem.value || fieldItem.value == '')
            "
          >
            <span
              style="color: #666666; margin-right: 20px"
              class="playerContentTitle"
              >{{ fieldItem.fieldName }}:</span
            >
            <span style="color: #999; font-size: 14px">无</span>
          </div>

          <!-- 图片 -->
          <div
            class="newContent mar15-0"
            v-else-if="
              (fieldItem.type == 5 || fieldItem.type == 35) &&
              fieldItem.value != '' &&
              (fieldItem.isOpen == 1 || isOtherPeople != 3)
            "
          >
            <span style="color: #666666" class="playerContentTitle">{{
              fieldItem.fieldName
            }}</span>
            <div class="content5-new">
              <div
                class="image-wrapper-new"
                v-for="(imgItem, imgIndex) in fieldItem.value"
                :key="imgIndex"
              >
                <img
                  class="con5-img"
                  :src="getFullImageUrl(imgItem)"
                  mode="aspectFill"
                  @click.stop="predivImageFn(fieldItem.value, imgIndex)"
                  v-if="fieldItem.value"
                />
                <span
                  style="color: #323b5f; font-size: 14px"
                  v-if="fieldItem.value.length == 0"
                  >无</span
                >
              </div>
            </div>
          </div>

          <!-- 视频 -->
          <div
            class="newContent mar15-0"
            v-else-if="
              fieldItem.type == 6 &&
              fieldItem.value != '' &&
              (fieldItem.isOpen == 1 || isOtherPeople != 3)
            "
          >
            <span
              style="color: #666666; margin-bottom: 8px; display: inline-block"
              class="playerContentTitle"
              >{{ fieldItem.fieldName }}</span
            >
            <video
              :src="fieldItem.videoUrl"
              controls
              v-if="fieldItem.videoUrl"
              style="
                max-width: 100%;
                width: 100%;
                height: auto;
                display: block;
                margin-bottom: 10px;
              "
            >
              Your browser does not support the video element.
            </video>
          </div>

          <!-- 录音 -->
          <div
            class="newContent mar15-0"
            v-else-if="
              fieldItem.type == 7 &&
              fieldItem.value != '' &&
              (fieldItem.isOpen == 1 || isOtherPeople != 3)
            "
          >
            <span
              style="color: #666666; margin-bottom: 8px; display: inline-block"
              class="playerContentTitle"
              >{{ fieldItem.fieldName }}</span
            >
            <div class="greenBtn1">
              <audio controls>
                <source :src="fieldItem.value.url" />
              </audio>
            </div>
          </div>

          <!-- 地图 -->
          <div
            class="newContent mar15-0"
            v-else-if="
              fieldItem.type == 12 &&
              fieldItem.value != '' &&
              (fieldItem.isOpen == 1 || isOtherPeople != 3)
            "
          >
            <div>
              <span
                style="color: #666666; margin-right: 20px"
                class="playerContentTitle"
                >{{ fieldItem.fieldName }}:</span
              >
              <span style="color: #323b5f; font-size: 14px">{{
                fieldItem.value.address ? fieldItem.value.address : "无"
              }}</span>
            </div>
            <div
              style="
                display: flex;
                align-items: center;
                flex-direction: column;
                margin-top: 8px;
              "
            >
              <div class="page-map" @click.stop="handleGoto(fieldItem.value)">
                <image
                  class="map-posi"
                  src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/bd-position3.svg"
                >
                </image>
                {{ fieldItem.value.name ? fieldItem.value.name : "无" }}
              </div>
            </div>
          </div>

          <!-- 手写签名 -->
          <div
            class="newContent mar15-0"
            v-else-if="
              fieldItem.type == 29 &&
              (fieldItem.isOpen == 1 || isOtherPeople != 3)
            "
          >
            <span
              style="color: #666666; margin-right: 20px; display: inline-block"
              :style="{
                marginBottom: fieldItem.value ? '7px' : '0',
              }"
              class="playerContentTitle"
              >{{ fieldItem.fieldName }}:
            </span>
            <span
              style="color: #323b5f; font-size: 14px"
              v-if="fieldItem.value == ''"
              >无</span
            >
            <div class="content5" style="background-color: #fff">
              <img
                :src="getFullImageUrl(fieldItem.value)"
                @click.stop="predivImageFn(getFullImageUrl(fieldItem.value), 0)"
                v-if="fieldItem.value"
              />
            </div>
          </div>

          <!-- 文件签字 -->
          <div
            class="newContent mar15-0"
            v-else-if="
              fieldItem.type == 36 &&
              (fieldItem.isOpen == 1 || isOtherPeople != 3)
            "
          >
            <span style="color: #666666" class="playerContentTitle">{{
              fieldItem.fieldName
            }}</span>
            <div class="content5-new">
              <div
                class="image-wrapper-new"
                v-for="(imgItem, imgIndex) in fieldItem.localvalue"
                :key="imgIndex"
              >
                <img
                  class="con5-img"
                  :src="getFullImageUrl(imgItem)"
                  mode="aspectFill"
                  @click.stop="seeBigImg(imgItem)"
                  v-if="fieldItem.localvalue"
                />
              </div>
              <span
                style="color: #323b5f; font-size: 14px"
                v-if="!fieldItem.localvalue"
                >无</span
              >
            </div>
          </div>
        </div>

        <!-- 操作按钮 -->
        <div
          v-if="
            showContentActionButtons &&
            isType != 101 &&
            isType != '101' &&
            (anonymousParticipation == 0 ||
              memberId == item.create_user_id ||
              isOtherPeople == 2 ||
              item.user_id == memberId)
          "
          class="d-flex"
        >
          <!-- 点赞 -->
          <div
            class="thumbs_box"
            @click.stop="handleThumbsUp"
            v-if="showThumbsUp"
          >
            <img
              :src="imageUrl2 + '/12jielong/lsyJL/already_liked.svg'"
              v-if="item.isDz == 'true'"
            />
            <img
              :src="imageUrl2 + '/12jielong/lsyJL/thumbs_up_hollow.svg'"
              v-if="item.isDz == 'false'"
            />
            <span
              :style="{
                color: item.isDz == 'false' ? '#3D4563' : '#1877ff',
              }"
            >
              {{ item.thumbs_up_number }}
            </span>
          </div>

          <!-- 评论 -->
          <div class="thumbs_box" @click="handleAddRemark" v-if="showComment">
            <img :src="imageUrl2 + '/12jielong/lsyJL/pinglun.png'" />
            <span style="color: #626262">{{ commentCount }}</span>
          </div>

          <!-- 核销 -->
          <div class="thumbs_box" @click="handleVerify" v-if="showVerify">
            <img
              style="height: 13px; width: 12px"
              src="@/assets/images/pitu.png"
            />
            <span style="color: #626262">核销</span>
          </div>

          <!-- 批图 -->
          <div
            class="thumbs_box"
            @click="handleBatchDrawing"
            v-if="showBatchDrawing"
          >
            <img
              style="height: 13px; width: 12px"
              src="@/assets/images/pitu.png"
            />
            <span style="color: #626262">批图</span>
          </div>

          <!-- 点评 -->
          <div
            class="thumbs_box"
            @click="handleCommentOpen"
            v-if="showCommentOpen"
          >
            <img
              style="height: 13px; width: 12px"
              src="@/assets/images/dianping.png"
            />
            <span style="color: #626262">点评</span>
          </div>

          <!-- 评分 -->
          <div
            class="thumbs_box"
            @click="handleOpenScoreDialog"
            v-if="showScore"
          >
            <img
              style="height: 13px; width: 12px"
              src="@/assets/images/score.png"
            />
            <span style="color: #626262">评分</span>
          </div>

          <!-- 修改 -->
          <div class="thumbs_box" @click="handleEditPlayer" v-if="showEdit">
            <img
              style="height: 13px; width: 12px"
              src="@/assets/images/edit.png"
            />
            <span style="color: #626262">修改</span>
          </div>

          <!-- 删除 -->
          <div class="thumbs_box" @click="handleDelSign" v-if="showDelete">
            <img
              style="height: 13px; width: 12px"
              src="@/assets/images/del.png"
            />
            <span style="color: #626262">删除</span>
          </div>

          <!-- 复制 -->
          <div class="thumbs_box" @click="handleCopyField" v-if="showCopy">
            <img
              style="height: 13px; width: 12px"
              src="https://ossfastmake.xlkapp.com/12jielong/lsyJL/copy.svg"
            />
            <span style="color: #626262">复制</span>
          </div>

          <!-- 允许他人查看 -->
          <div
            class="thumbs_box"
            @click="handleEditAllowView(1)"
            v-if="showAllowView && item.allow_viewing == 2"
          >
            <span style="color: #626262">允许他人查看</span>
          </div>

          <!-- 不允许他人查看 -->
          <div
            class="thumbs_box"
            @click="handleEditAllowView(2)"
            v-if="showAllowView && item.allow_viewing != 2"
          >
            <span style="color: #626262">不允许他人查看</span>
          </div>
        </div>

        <!-- 评论列表 -->
        <div
          class="pllist"
          style="position: relative"
          v-if="showComments && comments.length > 0"
        >
          <div
            v-for="(comment, commentIndex) in comments"
            :key="commentIndex"
            class="comment-item"
          >
            <span class="nickname">{{ comment.name }}:</span>
            <span class="comment-text">{{ comment.comment }}</span>
            <div
              class="del"
              @click="handleDelComment(comment)"
              v-if="
                comment.userId == memberId ||
                activityCreateUserId == memberId ||
                isOtherPeople == 2
              "
            >
              <i class="el-icon-delete"></i>
            </div>
          </div>
          <!-- 查看更多评论 -->
          <div
            v-if="hasMoreComments"
            class="more-box2"
            @click="handleSeeMoreComments"
          >
            点击查看更多评论
          </div>
        </div>
      </div>
    </div>

    <!-- 抽屉式详情 -->
    <el-drawer
      :visible.sync="isDrawerOpen"
      direction="rtl"
      :size="drawerSize"
      :withHeader="false"
      class="player-detail-drawer"
    >
      <div class="drawerOutBox">
        <div class="drawer-nav-top">
          <div></div>
          <span>参与者详情</span>
          <img
            src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png"
            class="close-btn"
            @click="handleCloseDrawer"
          />
        </div>
        <div class="underline"></div>
        <div class="drawer-content">
          <!-- 付费信息 -->
          <div
            class="footer_text"
            v-if="
              (item.charge_name || item.charge_item_name) &&
              item.unit_price !== undefined &&
              item.unit_price !== null &&
              item.unit_price !== ''
            "
          >
            <div class="mar15-0">
              <span class="playerContentTitle" style="font-weight: 600"
                >付费项:</span
              >
              <span style="color: #323b5f; font-size: 14px; font-weight: 600">{{
                item.charge_name || item.charge_item_name
              }}</span>
            </div>
            <div
              class="mar15-0"
              v-if="
                isOtherPeople == 1 ||
                isOtherPeople == 2 ||
                memberId == item.create_user_id
              "
            >
              <span class="playerContentTitle" style="font-weight: 600"
                >金额:</span
              >
              <span style="color: #323b5f; font-size: 14px; font-weight: 600"
                >¥{{ item.unit_price }}</span
              >
            </div>
          </div>

          <!-- 表单字段内容 -->
          <div
            class="footer_text"
            v-for="(fieldItem, fieldIndex) in item.sign_info"
            :key="fieldIndex"
          >
            <!-- 姓名/性别/手机号/数量/身份证/省市区/时间 -->
            <div
              class="mar15-0"
              v-if="
                (fieldItem.type == 1 ||
                  fieldItem.type == 2 ||
                  fieldItem.type == 11 ||
                  fieldItem.type == 13 ||
                  fieldItem.type == 3 ||
                  fieldItem.type == 10 ||
                  fieldItem.type == 8 ||
                  fieldItem.type == 4 ||
                  fieldItem.type == 15 ||
                  fieldItem.type == 19 ||
                  fieldItem.type == 21 ||
                  fieldItem.type == 22 ||
                  fieldItem.type == 23 ||
                  fieldItem.type == 24 ||
                  fieldItem.type == 25 ||
                  fieldItem.type == 26 ||
                  fieldItem.type == 27 ||
                  fieldItem.type == 28 ||
                  fieldItem.type == 31) &&
                (fieldItem.isOpen == 1 || isOtherPeople != 3)
              "
            >
              <div>
                <span
                  style="color: #666666; margin-right: 20px"
                  class="playerContentTitle"
                  >{{ fieldItem.fieldName }}:</span
                >
                <span style="color: #323b5f; font-size: 14px">{{
                  fieldItem.type == 1 && fieldIndex == 0 && item.list_group_name
                    ? item.list_group_name + "-" + (fieldItem.value || "无")
                    : fieldItem.value
                    ? fieldItem.value
                    : "无"
                }}</span>
              </div>
              <div
                v-if="
                  fieldItem.areaSelectType == 3 &&
                  fieldItem.provinceCityDistrictAddress != null
                "
              >
                <span style="color: #666666"></span
                >{{ fieldItem.provinceCityDistrictAddress }}
              </div>
            </div>

            <!-- 文件 -->
            <div
              v-if="
                fieldItem.type == 32 &&
                (fieldItem.isOpen == 1 || isOtherPeople != 3)
              "
              class="mar15-0"
            >
              <div>
                <span
                  style="color: #666666; margin-right: 20px"
                  class="playerContentTitle"
                  >{{ fieldItem.fieldName }}:</span
                >
                <span
                  v-if="fieldItem.value.length == 0"
                  style="color: #323b5f; font-size: 14px"
                  >无</span
                >
              </div>
              <div
                v-if="fieldItem.value != null"
                class="file-sign-box"
                style="margin-top: 7px"
              >
                <div
                  class="file-sign-item"
                  style="box-sizing: border-box"
                  v-for="(fileItem, fileIndex) in fieldItem.value"
                  :key="fileIndex"
                >
                  <div
                    class="con4 con4_flex"
                    @click="
                      openWen(
                        imageUrl2 + fileItem.fileUrl,
                        fileItem.lastName,
                        fileItem.name,
                      )
                    "
                  >
                    <div class="" style="align-items: center !important">
                      <div style="display: flex">
                        <div class="con4Img">
                          <img
                            v-if="fileItem.lastName == 'doc'"
                            :src="imageUrl2 + '/static/announcement/word.png'"
                            class="Img3"
                          />
                          <img
                            v-else-if="fileItem.lastName == 'docx'"
                            :src="imageUrl2 + '/static/announcement/word.png'"
                            class="Img3"
                          />
                          <img
                            v-else-if="fileItem.lastName == 'pdf'"
                            :src="imageUrl2 + '/static/announcement/PDF.png'"
                            class="Img3"
                          />
                          <img
                            v-else-if="fileItem.lastName == 'ppt'"
                            :src="imageUrl2 + '/static/announcement/PPT.png'"
                            class="Img3"
                          />
                          <img
                            v-else-if="fileItem.lastName == 'xls'"
                            :src="imageUrl2 + '/static/index/excel.png'"
                            class="Img3"
                          />
                          <img
                            v-else-if="fileItem.lastName == 'xlsx'"
                            :src="imageUrl2 + '/static/index/excel.png'"
                            class="Img3"
                          />
                          <img
                            v-else-if="fileItem.lastName == 'zip'"
                            src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/zip.svg"
                            class="Img3"
                          />
                        </div>
                        <div>{{ fileItem.name }}</div>
                      </div>

                      <div class="con4_1">
                        <span v-if="fileItem.size / 1024 <= 1">{{
                          setB(fileItem.size, fileItem.lastName)
                        }}</span>
                        <span
                          v-else-if="
                            fileItem.size / 1024 >= 1 &&
                            fileItem.size / 1048576 <= 1
                          "
                          >{{ setKb(fileItem.size, fileItem.lastName) }}</span
                        >
                        <span v-else-if="fileItem.size / 1048576 >= 1">{{
                          setMb(fileItem.size, fileItem.lastName)
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 多行文本 -->
            <div
              class="newContent mar15-0"
              v-else-if="
                fieldItem.type == 9 &&
                (fieldItem.isOpen == 1 || isOtherPeople != 3)
              "
            >
              <div class="nameMa">
                <span style="color: #666666" class="playerContentTitle"
                  >{{ fieldItem.fieldName }}:</span
                >
                <span> {{ fieldItem.value ? "" : "无" }}</span>
                <div
                  style="
                    color: #323b5f;
                    white-space: pre-wrap;
                    word-break: break-all;
                    word-wrap: break-word;
                    font-size: 14px;
                  "
                >
                  {{ fieldItem.value }}
                </div>
              </div>
            </div>

            <!-- 图片/视频/录音空值显示 -->
            <div
              class="newContent mar15-0"
              v-else-if="
                (fieldItem.type == 5 ||
                  fieldItem.type == 35 ||
                  fieldItem.type == 6 ||
                  fieldItem.type == 7) &&
                (fieldItem.isOpen == 1 || isOtherPeople != 3) &&
                (!fieldItem.value || fieldItem.value == '')
              "
            >
              <span
                style="color: #666666; margin-right: 20px"
                class="playerContentTitle"
                >{{ fieldItem.fieldName }}:</span
              >
              <span style="color: #999; font-size: 14px">无</span>
            </div>

            <!-- 图片 -->
            <div
              class="newContent mar15-0"
              v-else-if="
                (fieldItem.type == 5 || fieldItem.type == 35) &&
                fieldItem.value != '' &&
                (fieldItem.isOpen == 1 || isOtherPeople != 3)
              "
            >
              <span style="color: #666666" class="playerContentTitle">{{
                fieldItem.fieldName
              }}</span>
              <div class="content5-new">
                <div
                  class="image-wrapper-new"
                  v-for="(imgItem, imgIndex) in fieldItem.value"
                  :key="imgIndex"
                >
                  <img
                    class="con5-img"
                    :src="getFullImageUrl(imgItem)"
                    mode="aspectFill"
                    @click.stop="predivImageFn(fieldItem.value, imgIndex)"
                    v-if="fieldItem.value"
                  />
                  <span
                    style="color: #323b5f; font-size: 14px"
                    v-if="fieldItem.value.length == 0"
                    >无</span
                  >
                </div>
              </div>
            </div>

            <!-- 视频 -->
            <div
              class="newContent mar15-0"
              v-else-if="
                fieldItem.type == 6 &&
                fieldItem.value != '' &&
                (fieldItem.isOpen == 1 || isOtherPeople != 3)
              "
            >
              <span
                style="
                  color: #666666;
                  margin-bottom: 8px;
                  display: inline-block;
                "
                class="playerContentTitle"
                >{{ fieldItem.fieldName }}</span
              >
              <video
                :src="fieldItem.videoUrl"
                controls
                v-if="fieldItem.videoUrl"
                style="
                  max-width: 100%;
                  width: 100%;
                  height: auto;
                  display: block;
                  margin-bottom: 10px;
                "
              >
                Your browser does not support the video element.
              </video>
            </div>

            <!-- 录音 -->
            <div
              class="newContent mar15-0"
              v-else-if="
                fieldItem.type == 7 &&
                fieldItem.value != '' &&
                (fieldItem.isOpen == 1 || isOtherPeople != 3)
              "
            >
              <span
                style="
                  color: #666666;
                  margin-bottom: 8px;
                  display: inline-block;
                "
                class="playerContentTitle"
                >{{ fieldItem.fieldName }}</span
              >
              <div class="greenBtn1">
                <audio controls>
                  <source :src="fieldItem.value.url" />
                </audio>
              </div>
            </div>

            <!-- 地图 -->
            <div
              class="newContent mar15-0"
              v-else-if="
                fieldItem.type == 12 &&
                fieldItem.value != '' &&
                (fieldItem.isOpen == 1 || isOtherPeople != 3)
              "
            >
              <div>
                <span
                  style="color: #666666; margin-right: 20px"
                  class="playerContentTitle"
                  >{{ fieldItem.fieldName }}:</span
                >
                <span style="color: #323b5f; font-size: 14px">{{
                  fieldItem.value.address ? fieldItem.value.address : "无"
                }}</span>
              </div>
              <div
                style="
                  display: flex;
                  align-items: center;
                  flex-direction: column;
                  margin-top: 8px;
                "
              >
                <div class="page-map" @click.stop="handleGoto(fieldItem.value)">
                  <image
                    class="map-posi"
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/bd-position3.svg"
                  >
                  </image>
                  {{ fieldItem.value.name ? fieldItem.value.name : "无" }}
                </div>
              </div>
            </div>

            <!-- 手写签名 -->
            <div
              class="newContent mar15-0"
              v-else-if="
                fieldItem.type == 29 &&
                (fieldItem.isOpen == 1 || isOtherPeople != 3)
              "
            >
              <span
                style="
                  color: #666666;
                  margin-right: 20px;
                  display: inline-block;
                "
                :style="{
                  marginBottom: fieldItem.value ? '7px' : '0',
                }"
                class="playerContentTitle"
                >{{ fieldItem.fieldName }}:
              </span>
              <span
                style="color: #323b5f; font-size: 14px"
                v-if="fieldItem.value == ''"
                >无</span
              >
              <div class="content5" style="background-color: #fff">
                <img
                  :src="getFullImageUrl(fieldItem.value)"
                  @click.stop="
                    predivImageFn(getFullImageUrl(fieldItem.value), 0)
                  "
                  v-if="fieldItem.value"
                />
              </div>
            </div>

            <!-- 文件签字 -->
            <div
              class="newContent mar15-0"
              v-else-if="
                fieldItem.type == 36 &&
                fieldItem.value != '' &&
                (fieldItem.isOpen == 1 || isOtherPeople != 3)
              "
            >
              <span style="color: #666666" class="playerContentTitle">{{
                fieldItem.fieldName
              }}</span>
              <div class="content5-new">
                <div
                  class="image-wrapper-new"
                  v-for="(imgItem, imgIndex) in fieldItem.localvalue"
                  :key="imgIndex"
                >
                  <img
                    class="con5-img"
                    :src="getFullImageUrl(imgItem)"
                    mode="aspectFill"
                    @click.stop="seeBigImg(imgItem)"
                    v-if="fieldItem.localvalue"
                  />
                  <span
                    style="color: #323b5f; font-size: 14px"
                    v-if="fieldItem.localvalue.length == 0"
                    >无</span
                  >
                </div>
              </div>
            </div>
          </div>

          <!-- 操作按钮 -->
          <div v-if="showDrawerActionButtons" class="action-buttons">
            <!-- 点赞 -->
            <div
              class="thumbs_box"
              @click.stop="handleThumbsUp"
              v-if="showThumbsUp"
            >
              <img
                :src="imageUrl2 + '/12jielong/lsyJL/already_liked.svg'"
                v-if="item.isDz == 'true'"
              />
              <img
                :src="imageUrl2 + '/12jielong/lsyJL/thumbs_up_hollow.svg'"
                v-if="item.isDz == 'false'"
              />
              <span
                :style="{
                  color: item.isDz == 'false' ? '#3D4563' : '#1877ff',
                }"
              >
                {{ item.thumbs_up_number }}
              </span>
            </div>

            <!-- 评论 -->
            <div class="thumbs_box" @click="handleAddRemark" v-if="showComment">
              <img :src="imageUrl2 + '/12jielong/lsyJL/pinglun.png'" />
              <span style="color: #626262">{{ commentCount }}</span>
            </div>

            <!-- 核销 -->
            <div class="thumbs_box" @click="handleVerify" v-if="showVerify">
              <img
                style="height: 13px; width: 12px"
                src="@/assets/images/pitu.png"
              />
              <span style="color: #626262">核销</span>
            </div>

            <!-- 批图 -->
            <div
              class="thumbs_box"
              @click="handleBatchDrawing"
              v-if="showBatchDrawing"
            >
              <img
                style="height: 13px; width: 12px"
                src="@/assets/images/pitu.png"
              />
              <span style="color: #626262">批图</span>
            </div>

            <!-- 点评 -->
            <div
              class="thumbs_box"
              @click="handleCommentOpen"
              v-if="showCommentOpen"
            >
              <img
                style="height: 13px; width: 12px"
                src="@/assets/images/dianping.png"
              />
              <span style="color: #626262">点评</span>
            </div>

            <!-- 评分 -->
            <div
              class="thumbs_box"
              @click="handleOpenScoreDialog"
              v-if="showScore"
            >
              <img
                style="height: 13px; width: 12px"
                src="@/assets/images/score.png"
              />
              <span style="color: #626262">评分</span>
            </div>

            <!-- 修改 -->
            <div class="thumbs_box" @click="handleEditPlayer" v-if="showEdit">
              <img
                style="height: 13px; width: 12px"
                src="@/assets/images/edit.png"
              />
              <span style="color: #626262">修改</span>
            </div>

            <!-- 删除 -->
            <div class="thumbs_box" @click="handleDelSign" v-if="showDelete">
              <img
                style="height: 13px; width: 12px"
                src="@/assets/images/del.png"
              />
              <span style="color: #626262">删除</span>
            </div>

            <!-- 复制 -->
            <div class="thumbs_box" @click="handleCopyField" v-if="showCopy">
              <img
                style="height: 13px; width: 12px"
                src="https://ossfastmake.xlkapp.com/12jielong/lsyJL/copy.svg"
              />
              <span style="color: #626262">复制</span>
            </div>

            <!-- 允许他人查看 -->
            <div
              class="thumbs_box"
              @click="handleEditAllowView(1)"
              v-if="showAllowView && item.allow_viewing == 2"
            >
              <span style="color: #626262">允许他人查看</span>
            </div>

            <!-- 不允许他人查看 -->
            <div
              class="thumbs_box"
              @click="handleEditAllowView(2)"
              v-if="showAllowView && item.allow_viewing != 2"
            >
              <span style="color: #626262">不允许他人查看</span>
            </div>
          </div>

          <!-- 评论列表 -->
          <div class="pllist" v-if="showComments && comments.length > 0">
            <div
              v-for="(comment, commentIndex) in comments"
              :key="commentIndex"
              style="
                display: flex;
                margin-bottom: 8px;
                align-items: center;
                position: relative;
              "
            >
              <div class="comment-wrapper">
                <div class="plName">
                  <span class="nickname">{{ comment.name }}:</span>
                  <span class="comment-text">{{ comment.comment }}</span>
                </div>
                <div
                  class="del"
                  style="
                    position: absolute;
                    right: 0;
                    top: 50%;
                    transform: translateY(-50%);
                  "
                  @click="handleDelComment(comment)"
                  v-if="
                    comment.userId == memberId ||
                    activityCreateUserId == memberId ||
                    isOtherPeople == 2
                  "
                >
                  <i class="el-icon-delete"></i>
                </div>
              </div>
            </div>
            <!-- 查看更多评论 -->
            <div
              v-if="hasMoreComments"
              class="more-box2"
              @click="handleSeeMoreComments"
            >
              点击查看更多评论
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: "ActivityPlayerItem",
  props: {
    // 参与者数据
    item: {
      type: Object,
      required: true,
    },
    // 是否显示头像（非匿名）
    showAvatar: {
      type: Boolean,
      default: true,
    },
    // 显示的名称（支持加密逻辑）
    displayName: {
      type: String,
      default: "",
    },
    // 匿名头像 URL
    anonymousHeadUrl: {
      type: String,
      default:
        "https://ossfastmake.xlkapp.com//12jielong/lsyJL/anonymoushead.png",
    },
    // 图片基础 URL
    imageUrl2: {
      type: String,
      default: "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/",
    },
    // 当前用户 ID
    memberId: {
      type: [String, Number],
      default: "",
    },
    // 活动创建者 ID
    activityCreateUserId: {
      type: [String, Number],
      default: "",
    },
    // 是否他人查看模式
    isOtherPeople: {
      type: [String, Number],
      default: "",
    },
    // 活动类型
    isType: {
      type: [String, Number],
      default: "",
    },
    // 匿名参与设置（0 显示，1 匿名）
    anonymousParticipation: {
      type: Number,
      default: 0,
    },
    // 是否显示内容（列表模式下的表单字段）
    showContent: {
      type: Boolean,
      default: false,
    },
    // 是否显示列表模式下的操作按钮
    showContentActionButtons: {
      type: Boolean,
      default: false,
    },
    // 是否显示抽屉内的操作按钮
    showDrawerActionButtons: {
      type: Boolean,
      default: true,
    },
    // 是否显示操作按钮（通用）
    showActionButtons: {
      type: Boolean,
      default: true,
    },
    // 是否显示点赞按钮
    showThumbsUp: {
      type: Boolean,
      default: false,
    },
    // 是否显示评论按钮
    showComment: {
      type: Boolean,
      default: false,
    },
    // 是否显示核销按钮
    showVerify: {
      type: Boolean,
      default: false,
    },
    // 是否显示批图按钮
    showBatchDrawing: {
      type: Boolean,
      default: false,
    },
    // 是否显示点评按钮
    showCommentOpen: {
      type: Boolean,
      default: false,
    },
    // 是否显示评分按钮
    showScore: {
      type: Boolean,
      default: false,
    },
    // 是否显示修改按钮
    showEdit: {
      type: Boolean,
      default: false,
    },
    // 是否显示删除按钮
    showDelete: {
      type: Boolean,
      default: false,
    },
    // 是否显示复制按钮
    showCopy: {
      type: Boolean,
      default: false,
    },
    // 是否显示允许他人查看按钮
    showAllowView: {
      type: Boolean,
      default: false,
    },
    // 是否显示评论列表
    showComments: {
      type: Boolean,
      default: false,
    },
    // 评论列表
    comments: {
      type: Array,
      default: () => [],
    },
    // 评论数量
    commentCount: {
      type: [Number, String],
      default: 0,
    },
    // 是否有更多评论
    hasMoreComments: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isDrawerOpen: false,
      drawerSize: "450px",
    };
  },
  computed: {
    // 兼容旧的 showActionButtons prop
    effectiveDrawerActionButtons() {
      return this.showDrawerActionButtons && this.showActionButtons;
    },
  },
  methods: {
    // 打开抽屉
    // 关闭抽屉
    handleCloseDrawer() {
      this.isDrawerOpen = false;
      this.$emit("close", this.item);
    },
    // 打开文件
    openWen(url, lastName, name) {
      this.$emit("open-file", { url, lastName, name });
    },
    // 设置文件大小显示
    setB(size, fileType) {
      this.$emit("format-file-size", { size, fileType });
    },
    setKb(size, fileType) {
      this.$emit("format-file-size", { size, fileType });
    },
    setMb(size, fileType) {
      this.$emit("format-file-size", { size, fileType });
    },
    // 获取完整图片 URL
    getFullImageUrl(url) {
      if (!url) return "";
      return url.startsWith("http") ? url : this.imageUrl2 + url;
    },
    // 预览图片
    predivImageFn(images, index) {
      this.$emit("preview-image", { images, index });
    },
    // 查看大图
    seeBigImg(img) {
      this.$emit("preview-image", { images: [img], index: 0 });
    },
    // 跳转地图
    handleGoto(value) {
      this.$emit("goto-map", value);
    },
    // 点赞
    handleThumbsUp() {
      this.$emit("thumbs-up", this.item);
    },
    // 添加评论
    handleAddRemark() {
      this.$emit("add-remark", this.item);
    },
    // 核销
    handleVerify() {
      this.$emit("verify", this.item);
    },
    // 批图
    handleBatchDrawing() {
      this.$emit("batch-drawing", this.item);
    },
    // 点评
    handleCommentOpen() {
      this.$emit("comment-open", this.item);
    },
    // 评分
    handleOpenScoreDialog() {
      this.$emit("open-score", this.item);
    },
    // 修改
    handleEditPlayer() {
      this.$emit("edit-player", this.item);
    },
    // 删除
    handleDelSign() {
      this.$emit("del-sign", this.item);
    },
    // 复制
    handleCopyField() {
      this.$emit("copy-field", this.item);
    },
    // 允许他人查看
    handleEditAllowView(type) {
      this.$emit("edit-allow-view", { item: this.item, type });
    },
    // 删除评论
    handleDelComment(comment) {
      this.$emit("del-comment", { comment, item: this.item });
    },
    // 查看更多评论
    handleSeeMoreComments() {
      this.$emit("see-more-comments", this.item.id);
    },
  },
};
</script>

<style scoped lang="scss">
.player-item-wrapper {
  width: 100%;
  position: relative;
  background-color: #fff;

  .titleT {
    width: 100%;
    padding: 15px 20px 0;
    cursor: pointer;

    .titleCon {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;

      .titleTop {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .tx {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          flex: 1;

          .header {
            margin-right: 8px;
            img {
              width: 47px;
              height: 47px;
              border: 1px solid #ccc;
              border-radius: 50%;
            }
          }

          .content_con {
            flex: 1;

            .Biao {
              font-weight: bold;
              font-size: 15px;
              color: #323b5a;
              display: flex;
              align-items: center;

              .no-see {
                width: 16px;
                height: 16px;
                margin-left: 5px;
              }
            }

            .niming {
              font-weight: bold;
              font-size: 15px;
              color: #323b5a;
              display: flex;
              align-items: center;

              .no-see {
                width: 16px;
                height: 16px;
                margin-left: 5px;
              }
            }

            .time {
              font-size: 12px;
              font-weight: Regular;
              text-align: left;
              color: #666666;
              margin-top: 4px;
            }
          }
        }

        .xuhao {
          min-width: 40px;
          height: 26px;
          padding: 0 10px;
          border-radius: 13px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          font-weight: bold;
          color: #666;
          margin-left: 15px;
          flex-shrink: 0;
        }
      }

      .comment_cont {
        margin-top: 10px;
        width: 100%;
        background: #e8f2ff;
        border-radius: 2px;
        padding: 7px 8px;
        font-size: 14px;
        text-align: left;
        color: #1877ff;
        line-height: 20px;
      }
    }
  }

  // 列表模式下的内容样式
  .content {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: 0 20px 15px;

    .bmfooter {
      width: 100%;
      font-size: 14px;
      color: #626974;
      box-sizing: border-box;
      padding: 0 20px;

      .footer_text {
        .mar15-0 {
          margin: 8px 0;
        }

        span {
          word-break: break-all;
        }

        .playerContentTitle {
          color: #666;
          font-size: 13px;
        }
      }

      // 操作按钮
      .d-flex {
        display: flex;
        flex-wrap: wrap;
        margin-top: 10px;

        .thumbs_box {
          display: flex;
          align-items: center;
          margin-right: 33px;
          cursor: pointer;
          margin-top: 5px;

          img {
            width: 12px;
            height: 11px;
            margin-right: 4px;
          }

          span {
            font-size: 14px;
            font-weight: Regular;
            text-align: left;
            color: #1877ff;
          }
        }
      }

      // 评论列表
      .pllist {
        width: 100%;
        min-height: 50px;
        background: #eef2f7;
        border-radius: 10px;
        padding: 8px;
        margin-top: 10px;

        .comment-item {
          position: relative;
          width: 95%;
          display: flex;
          margin-bottom: 8px;
          align-items: center;
          font-size: 14px;
          font-weight: bold;
          text-align: left;
          color: #666666;
          margin: 8px 8px;

          .nickname {
            font-weight: bold;
            color: #666666;
          }

          .comment-text {
            color: #666666;
            margin-left: 5px;
          }

          .del {
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            cursor: pointer;
            color: #999;
            font-size: 14px;

            &:hover {
              color: #f44;
            }
          }
        }

        .more-box2 {
          text-align: center;
          padding: 10px;
          color: #1877ff;
          cursor: pointer;
          font-size: 13px;
        }
      }

      // 文件列表样式
      .file-sign-box {
        .file-sign-item {
          padding: 10px;
          background: #f9f9f9;
          border-radius: 4px;
          margin-bottom: 8px;

          .con4.con4_flex {
            display: flex;
            justify-content: space-between;
            align-items: center;
            cursor: pointer;

            .con4Img {
              display: flex;
              align-items: center;
              margin-right: 10px;

              .Img3 {
                width: 32px;
                height: 32px;
              }
            }

            .con4_1 {
              font-size: 12px;
              color: #999;
            }
          }
        }
      }

      // 图片列表样式
      .content5-new {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        margin-top: 8px;

        .image-wrapper-new {
          position: relative;

          .con5-img {
            width: 100px;
            height: 100px;
            object-fit: cover;
            border-radius: 4px;
            cursor: pointer;
          }
        }
      }

      // 地图样式
      .page-map {
        display: flex;
        align-items: center;
        padding: 10px 15px;
        background: #f5f7fa;
        border-radius: 4px;
        cursor: pointer;
        margin-top: 8px;

        .map-posi {
          width: 20px;
          height: 20px;
          margin-right: 8px;
        }
      }

      // 录音样式
      .greenBtn1 {
        audio {
          max-width: 100%;
        }
      }
    }
  }
}
</style>
